import React from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import { MenuItem } from '@mui/material'
import MuiSelectWrapper from 'gui/components/common/MuiSelect'
import PRODUCT_TYPE_OPTIONS from './options'
import './index.scss'

/**
 * Component for content product type drop down
 * @param {Object} props The props
 * @param {String} props.onChange An options onChange funciton
 * @param {String} props.value The value
 * @param {String} props.label The label
 * @param {String} props.name The DOM element name
 * @param {String} props.className The classname
 * @param {String} props.defaultValue The default value
 * @param {String} props.required When true the value is required
 * @param {String} props.id The DOM element id
 * @param {Boolean} props.disabled When true component is disabled
 */
export default function ContentProductTypeSelect (props) {
  const {
    className,
    contentType,
    defaultValue,
    disabled,
    id,
    label,
    name,
    onChange,
    required,
    value,
    noMargin,
  } = props
  if (!PRODUCT_TYPE_OPTIONS.has(contentType)) {
    return null
  }
  return (
    <MuiSelectWrapper
      id={id}
      name={name}
      className={className}
      label={label}
      onChange={onChange}
      value={value}
      defaultValue={defaultValue}
      disabled={disabled}
      required={required}
      noMargin={noMargin}
    >
      {PRODUCT_TYPE_OPTIONS.get(contentType, Map()).map((option) => (
        <MenuItem value={option.get('value')} key={`product-type-${option.get('value')}`}>
          {option.get('label')}
        </MenuItem>
      ))}
    </MuiSelectWrapper>
  )
}

ContentProductTypeSelect.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  contentType: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.string,
  noMargin: PropTypes.bool,
}

ContentProductTypeSelect.defaultProps = {
  label: 'Product type',
  name: 'productType',
}
